<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="img/altamente-text.svg"
          width="150"
          height="35"
          alt="altamente logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/altamente.svg"
          width="35"
          height="35"
          alt="altamente logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <!--b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      <!--b-nav-item class="px-3" to="/users" exact>Users</b-nav-item-->
      <!--b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav-->
      <b-navbar-nav class="ml-auto">
        <!--b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item-->
        <DefaultHeaderDropdownAccnt />
        <b-nav-item v-on:click="logout">
          <i class="cui-account-logout"></i>
        </b-nav-item>
      </b-navbar-nav>
      <!--AsideToggler class="d-none d-lg-block" /-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav(profile)"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://www.altamente.cloud">
          <b>altamente</b>
        </a>
        <span class="ml-1">
          &copy; 2020
          <b>YURI GOLUB</b>
        </span>
      </div>
      <!--div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div-->
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import auth from '@/auth'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items
    }
  },
  computed: {
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    },
    profile() {
      return this.$store.state.profile
    }
  },
  created() {
    this.$store.dispatch('profile/getProfile')
  },
  methods: {
    logout: function () {
      auth.signOut();
    }
  }
}
</script>
<style>
/* @import url("https://file.myfontastic.com/FZ8NrkvZBsQ5Vtzn83KkgA/icons.css"); */
@import url("/assets/styles.css");
@media (max-width: 767px) {
  .main .container-fluid {
    padding: 0 !important;
  }
}
@media (min-width: 768px) {
  .main .container-fluid {
    padding: 0 30px !important;
  }
}
</style>
